'use strict';

var importer = angular.module('gymsystem.importer', []);

importer.controller('ImportCtrl', ['$rootScope', '$scope', 'server', '$filter', '$controller', 'alertProvider', 'util', 'formatter', '$q', function($rootScope, $scope, server, $filter, $controller, alertProvider, util, formatter, $q) {
    $controller('AddCtrl', {$scope: $scope});

    var importtypes = [{id: 'add', name: 'IMPORTADD'}, {id:'update', name:'IMPORTUPDATE'}];
    $scope.importstatus = {};
    $scope.sheet = 0;

    $scope.step = {
        __index: 0,
        list: [
            {
                fields: [
                    { name: 'type', title: 'Type', type: 'select', options: function() { return $scope.importdata && $scope.importdata.types; }, optionsFilter: function(f) { return $scope.isUpdate() ? f.canupdate : f.canimport; }, useId: true, required: true, orderPredicate: 'translated' },
                    { name: 'file', title: 'File', type: 'excel', required: true},
                    { name: 'importtype', title: 'What shall be done', type: 'select', required: true, options: function() { return importtypes; }, useId: true, value: importtypes[0] }
                ],
                canSubmit: function() {
                    return $scope.getFile();
                },
                getButtonText: function() {
                    return 'Continue';
                },
                submit: function() {
                    $scope.loadingStatus.loading = true;
                    var item = $scope.getSubmitItem();
                    $scope.sheet = 0;
                    $scope.getColumnsFromFile(item.type, item.file).then(function() {
                        $scope.step.__index = $scope.sheets.length == 1 ? 2 : 1;
                        _.findWhere($scope.step.list[1].fields, {name: 'sheet'}).value = _.findWhere(_.findWhere($scope.step.list[1].fields, {name: 'sheet'}).options(), {id: 0});
                        $scope.loadingStatus.loading = false;
                    }, function() {
                        $scope.loadingStatus.loading = false;
                    });
                }
            },
            {
                getButtonText: function() {
                    return 'Continue';
                },
                showButton2: function() {
                    return true;
                },
                getButtonText2: function() {
                    return 'Previous';
                },
                button2class: function() {
                    return 'btn-secondary';
                },
                submit2: function() {
                    --$scope.step.__index;
                },
                submit: function() {
                    $scope.loadingStatus.loading = true;
                    $scope.sheet = util.getSubmitItem($scope.step.list[1].fields).sheet;
                    var item = util.getSubmitItem($scope.step.list[0].fields);
                    $scope.getColumnsFromFile(item.type, item.file).then(function() {
                        $scope.step.__index++;
                        $scope.loadingStatus.loading = false;
                    }, function() {
                        $scope.loadingStatus.loading = false;
                    });
                },
                fields: [
                    {name: 'sheet', title: 'Sheet', type: 'select', options: function() { return $scope.sheets; }, visible: function() { return $scope.sheets && $scope.sheets.length > 1; }, required: true, useId: true }
                ]
            },
            {
                getButtonText: function() {
                    return 'Continue';
                },
                showButton2: function() {
                    return true;
                },
                getButtonText2: function() {
                    return 'Previous';
                },
                button2class: function() {
                    return 'btn-secondary';
                },
                submit2: function() {
                    if ($scope.sheets.length == 1) {
                        $scope.step.__index = 0;
                    } else {
                        _.findWhere($scope.step.list[1].fields, {name: 'sheet'}).value = _.findWhere(_.findWhere($scope.step.list[1].fields, {name: 'sheet'}).options(), {id: $scope.sheet});
                        $scope.step.__index--;
                    }
                },
                canSubmit: function() {
                    return $scope.getMissingRequiredFields().length == 0;
                },
                submit: function() {
                    var type = _.findWhere($scope.step.list[0].fields, {name: 'type'}).value.id;
                    var file = _.findWhere($scope.step.list[0].fields, {name: 'file'}).value;
                    var importtype = _.findWhere($scope.step.list[0].fields, {name: 'importtype'}).value.id;
                    $scope.loadingStatus.loading = true;

                    var field_mapping = {};
                    $scope.columns_from_file.header.forEach(function(c, index) {
                        if ($scope.headerToField[index]) {
                            field_mapping[c] = $scope.headerToField[index].id;
                        }
                    });

                    var link = util.getSubmitItem($scope.step.list[2].fields);
                    var data = {type: type, dryrun: true, field_mapping: field_mapping, link: link, sheet: $scope.sheet, importtype: importtype };
                    $scope.step.list[2].fields.forEach(function(f) {
                        if(!f.option) {return;}
                        if(f.name in link) {
                            data[f.name] = link[f.name];
                            delete link[f.name];
                        }
                    });

                    server.postFile('/api/import/import', file, null, null, null, data).then(function(result) {
                        if (result.success) {
                            result.data.errors.forEach(function(e) {
                                if (e.message == 'missing') {
                                    e.message = $filter('translate')('Could not find {0}').format($filter('translate')(e.arg));
                                }
                            });
                            $scope.dryrunresult = result.data;
                            $scope.dryrunresult.type = _.findWhere($scope.importdata.types, {id: type});
                            $scope.step.__index = 3;
                        } else {
                            alertProvider.modal('Error', 'Error loading file');
                        }
                        $scope.loadingStatus.loading = false;
                    });
                }
            },
            {
                getButtonText: function() {
                    return $scope.dryrunresult.errors.length ? 'Retry' : ($scope.isUpdate() ? 'Update' : 'Import');
                },
                showButton2: function() {
                    return true;
                },
                getButtonText2: function() {
                    return 'Previous';
                },
                button2class: function() {
                    return 'btn-secondary';
                },
                submit2: function() {
                    $scope.step.__index--;
                },
                submit: function() {
                    if ($scope.dryrunresult.errors.length) {
                        $scope.step.list[2].submit();
                    } else {
                        var type = _.findWhere($scope.step.list[0].fields, {name: 'type'}).value.id;
                        var file = _.findWhere($scope.step.list[0].fields, {name: 'file'}).value;
                        var importtype = _.findWhere($scope.step.list[0].fields, {name: 'importtype'}).value.id;
                        $scope.loadingStatus.loading = true;

                        var field_mapping = {};
                        $scope.columns_from_file.header.forEach(function(c, index) {
                            if ($scope.headerToField[index]) {
                                field_mapping[c] = $scope.headerToField[index].id;
                            }
                        });

                        var link = util.getSubmitItem($scope.step.list[2].fields);
                        var data = {type: type, field_mapping: field_mapping, link: link, sheet: $scope.sheet, importtype: importtype };
                        $scope.step.list[2].fields.forEach(function(f) {
                            if(!f.option) {return;}
                            if(f.name in link) {
                                data[f.name] = link[f.name];
                                delete link[f.name];
                            }
                        });

                        server.postFile('/api/import/import', file, null, null, null, data).then(function(result) {
                            $scope.importstatus.success = result && result.success;
                            $scope.importstatus.response_file = result && result.data && result.data.response_file;
                            $scope.step.__index++;
                            $scope.loadingStatus.loading = false;
                        });
                    }
                }
            },
            {
                getButtonText: function() {
                    return 'Ok';
                },
                submit: function() {
                    $scope.step.list.forEach(function(s) {
                        if (s.fields) {
                            s.fields.forEach(function(f) {
                                delete f.value;
                            });
                        }
                    });
                    $scope.step.__index = 0;
                    $scope.importstatus = {};
                    $scope.dryrunresult = undefined;
                    $scope.headerToField = [];

                    _.findWhere($scope.step.list[0].fields, {name: 'importtype'}).value = importtypes[0];
                    _.findWhere($scope.step.list[0].fields, {name: 'type'}).value = _.findWhere($scope.importdata.types, {id: 'user'});
                },
                showButton2: function() {
                    return !$scope.importstatus.success;
                },
                getButtonText2: function() {
                    return 'Previous';
                },
                button2class: function() {
                    return 'btn-secondary';
                },
                submit2: function() {
                    --$scope.step.__index;
                },
            }
        ]
    };

    $scope.headerToField = [];

    server.get('/api/import/types/get').then(function(data) {
        $scope.importdata = data;
        data.types.forEach(function(t) {
            t.translated = $filter('translate')(t.name);
            (t.fields || []).forEach(function(f) {
                f.translated = $filter('translate')(f.title);
            });

        });
        _.findWhere($scope.step.list[0].fields, {name: 'type'}).value = _.findWhere(data.types, {id: 'user'});
    });

    $scope.isUpdate = function() {
        return _.findWhere($scope.step.list[0].fields, {name: 'importtype'}).value.id == 'update';
    };

    $scope.getColumnsFromFile = function(type, file) {
        var data = {sheet: $scope.sheet};
        return server.postFile('/api/import/columns_from_file', file, null, null, null, data).then(function(result) {
            if (result.success) {
                $scope.columns_from_file = result.data;
                $scope.sheets = result.data.sheets.map(function(sname, index) {
                    return {id: index, name: sname};
                });

                var columns = result.data.header.map(function(id) {
                    return {id: id, name: id};
                });
                let fields_step2 = $scope.step.list[2].fields = [];

                $scope.headerToField = [];

                var update = $scope.isUpdate();
                var fields = _.findWhere($scope.importdata.types, {id: type}).fields.filter(function(f) { return update || !f.readonly; });
                fields.forEach(function(field) {
                    if (update) {
                        if (field.orequired === undefined) {
                            field.orequired = field.required;
                        }
                        field.required = field.id == 'id';
                    } else {
                        if (field.orequired !== undefined) {
                            field.required = field.orequired;
                        }
                    }
                });
                $scope.selectableFields = fields;

                var guessValueForField = function(field, linktypes) {
                    var checkers = {
                        mail: function(x) {
                            return x && angular.isString(x) && x.includes('@');
                        },
                        personalCodeNumber: function(x) {
                            return util.isValidPersonalCode(x);
                        },
                        number: function(x) {
                            return Number.isInteger(Number(x)) && Number(x) > 0;
                        }
                    };

                    // 1. get the column
                    var column = $scope.columns_from_file.header[$scope.headerToField.indexOf(field)];
                    if (!column) {
                        return;
                    }

                    if (linktypes.length == 1) {
                        return linktypes[0];
                    }

                    // 2. get the values in the column
                    var values = _.pluck($scope.columns_from_file.items, column);

                    // 3. select among link types
                    var is_mail = _.every(values, checkers.mail);
                    var is_pcode = _.every(values, checkers.mail);
                    var is_number = _.every(values, checkers.number);
                    if (is_mail) {
                        return _.findWhere(linktypes, {id: 'mail'});
                    }

                    if (is_pcode) {
                        return _.findWhere(linktypes, {id: 'personalCodeNumber'});
                    }

                    if (is_number) {
                        var with_number = linktypes.filter(function(x) { return x.type == 'number'; });
                        if (with_number.length == 1) {
                            return with_number[0];
                        }
                    } else {
                        var not_number = linktypes.filter(function(x) { return x.type != 'number'; });
                        if (not_number.length == 1) {
                            return not_number[0];
                        }
                    }
                };

                $scope.fieldOptionsFilter = columns.map(function(column, cindex) {
                    return function(f) {
                        if ($scope.headerToField[cindex] == f) {
                            return true;
                        }

                        return $scope.headerToField.indexOf(f) == -1;
                    };
                });

                columns.forEach(function(column, index) {
                    var field = _.find($scope.selectableFields.filter($scope.fieldOptionsFilter[index]) , function(f) {
                        return f.title == column.id || $filter('translate')(f.title) == column.id;
                    });
                    if (field) {
                        $scope.headerToField[index] = field;
                    }
                });

                fields.forEach(function(field) {
                    if (field.link) {
                        var link = _.findWhere($scope.importdata.types, {id: field.link});
                        var linktypes = link.fields.filter(function(f) { return f.unique; }).map(function(f) { return {id: f.id, name: f.title, type: f.type}; });
                        var showit = function() { return $scope.headerToField.indexOf(field) != -1; };
                        var value = guessValueForField(field, linktypes);
                        var title = $filter('translate')(field.title) + ' (' + $filter('translate')(link.name) + ')';
                        if ($scope.isUpdate()) {
                            title = link.one;
                        }
                        $scope.step.list[2].fields.push( {name: field.id, title: title, type: 'select', required: true, useId: true, options: function() { return linktypes; }, visible: showit, value: value } );
                    }
                });

                fields_step2.push({
                    title: 'Ignore error rows',
                    name: 'skip_errors',
                    type: 'checkbox',
                    option: true
                });

                fields_step2.push({
                    title: 'Reset double values',
                    name: 'reset_double',
                    type: 'checkbox',
                    option: true
                });

                fields_step2.push({
                    title: 'Skip empty values',
                    name: 'skip_empty',
                    type: 'checkbox',
                    value: true,
                    option: true
                });

                fields_step2.push({
                    title: 'Create payments',
                    name: 'create_payments',
                    type: 'checkbox',
                    option: true,
                    visible: function() {
                        var type = _.findWhere($scope.step.list[0].fields, {name: 'type'}).value.id;
                        return type === 'trainingcard';
                    }
                });
            } else {
                if(result.data.type == 'input' && result.data.message) {
                    alertProvider.modal('Error', result.data.message);
                } else {
                    alertProvider.modal('Error', 'Error loading file');
                }
                return $q.reject();
            }
        });
    };

    $scope.getFields = function() {
        return $scope.step.list[$scope.step.__index].fields;
    };

    $scope.getTitle = function(name) {
        return name && _.findWhere($scope.getFields(), {name: $rootScope.getRealFormName(name)}).title;
    };

    $scope.getButtonText = function() {
        return $scope.step.list[$scope.step.__index].getButtonText && $scope.step.list[$scope.step.__index].getButtonText();
    };

    $scope.showButton2 = function() {
        return $scope.step.list[$scope.step.__index].showButton2 && $scope.step.list[$scope.step.__index].showButton2();
    };

    $scope.getButtonText2 = function() {
        return $scope.step.list[$scope.step.__index].getButtonText2 && $scope.step.list[$scope.step.__index].getButtonText2();
    };

    $scope.submit2 = function() {
        if ($scope.step.list[$scope.step.__index].submit2) {
            $scope.step.list[$scope.step.__index].submit2();
        }
    };

    $scope.button2class = function() {
        return $scope.step.list[$scope.step.__index].button2class && $scope.step.list[$scope.step.__index].button2class();
    };

    $scope.canSubmit = function() {
        var s = $scope.step.list[$scope.step.__index];
        return !s.canSubmit || s.canSubmit();
    };

    $scope.submit = function() {
        $scope.step.list[$scope.step.__index].submit();
    };

    $scope.getFile = function() {
        var f =_.findWhere($scope.step.list[0].fields, {name: 'file'});
        return f && f.value;
    };

    $scope.getSelectableFields = function() {
        return $scope.selectableFields;
    };

    $scope.showMatchHint = function() {
        return $scope.step.__index == 2 && $scope.getFields().filter(function(f) { return !f.visible || f.visible(); }).length;
    };

    $scope.getMissingRequiredFields = function() {
        var required = $scope.getSelectableFields().filter(function(f) { return f.required; });
        return required.filter(function(f) {
            var computed = $scope.headerToField.filter(function(inf) {
                return inf && inf.computed && inf.computed.indexOf(f.id) != -1;
            });

            return computed.length == 0 && $scope.headerToField.indexOf(f) == -1;
        });
    };

    $scope.getNumberOfUsedColumns = function() {
        return $scope.headerToField.filter(function(f) { return f; }).length;
    };

    $scope.getNameOfImportType = function() {
        return _.findWhere($scope.step.list[0].fields, {name: 'type'}).value.one;
    };

    $scope.checkValue = function(item, header) {
        var value = item[header];
        if (value == null || value == '') {
            return true;
        }
        var f = $scope.headerToField[$scope.columns_from_file.header.indexOf(header)];
        var multiple = f.multiple;
        if (f.link) {
            var link = _.findWhere($scope.step.list[2].fields, {name: f.id}).value;
            if (!link) {
                return '-';
            }
            f = link;
        }
        if (!f.type || f.type == 'text' || f.type == 'textarea') {
            return true;
        }

        if (f.enum) {
            return f.enum.indexOf(String(value)) != -1;
        }

        if (f.type == 'date') {
            if (isNaN(value)) {
                var check = value.length == 10 && value[4] == '-' && value[7] == '-';
                if (!check) {
                    return false;
                }
                var y = Number(value.substring(0, 4));
                var m = Number(value.substring(5, 7));
                var d = Number(value.substring(8, 10));
                return y > 1900 && y < 2100 && m >= 1 && m <= 12 && d >= 1 && d <= 31;
            } else {
                return true;
            }
        } else if (f.type == 'datetime') {
            if (isNaN(value)) {
                // 2018-11-10 20:30[:00]
                var check = value.length >= 16 && value[4] == '-' && value[7] == '-' && value[10] == ' ' && value[13] == ':';
                if (!check) {
                    return false;
                }
                var y = Number(value.substring(0, 4));
                var m = Number(value.substring(5, 7));
                var d = Number(value.substring(8, 10));
                var H = Number(value.substring(11, 13));
                var M = Number(value.substring(14, 16));
                return y > 1900 && y < 2100 && m >= 1 && m <= 12 && d >= 1 && d <= 31 && H >= 0 && H <= 23 && M >= 0 && M <= 59;
            } else {
                return true;
            }
        } else if (f.type == 'mail' || f.type == 'email') {
            value = String(value);
            value = multiple ? value.split(';') : [value];
            return _.all(value, util.isValidMail);
        } else if (f.type == 'personalCodeNumber') {
            value = String(value);
            value = multiple ? value.split(';') : [value];
            return _.all(value, util.isValidCorporateIdentity);
        } else if (f.type == 'number') {
            value = String(value);
            value = multiple ? value.split(';') : [value];
            return _.all(value, function(value) { return parseInt(value) == value && parseInt(value) >= 0; });
        } else if (f.type == 'checkbox') {
            value = String(value).toLowerCase();
            return ['1', '0', 'ja', 'nej', 'yes', 'no'].indexOf(value) != -1;
        } else if (f.type == 'price') {
            value = String(value).replace(',', '.');
            return !isNaN(Number(value));
        }
    };

    $scope.getFormatter = function(header) {
        var f = $scope.headerToField[$scope.columns_from_file.header.indexOf(header)];
        if (f) {
            if (f.type == 'date') {
                return 'exceldate';
            } else if (f.type == 'datetime') {
                return 'exceldatetime';
            }
        }
    };

    $scope.getType = function(header) {
        var f = $scope.headerToField[$scope.columns_from_file.header.indexOf(header)];
        if (f) {
            var m = f.multiple ? ' - ' + $filter('translate')('multiple') : '';
            if (f.link) {
                var link = _.findWhere($scope.step.list[2].fields, {name: f.id}).value;
                if (!link) {
                    return '-';
                }
                f = link;
            }

            var types = {'date': 'Date', 'datetime': 'Date and time', 'number': 'Number', 'checkbox': 'Yes or no', 'text': 'Text', 'email': 'E-mail', 'mail': 'E-mail', 'textarea': 'Text', 'gender': 'male, female, other', 'phone': 'Phone number', 'personalCodeNumber': 'Personal code number', 'price': 'Price'};
            var type = $filter('translate')(types[f.type] || 'Text');
            if (f.enum) {
                type = formatter.format('commaList', f.enum);
            }
            return type + m;
        } else {
            return '-';
        }
    };
}]);

importer.controller('ImportToolsCtrl', ['$rootScope', '$scope', 'server', '$filter', '$controller', 'util', function($rootScope, $scope, server, $filter, $controller, util) {
    $controller('AddCtrl', {$scope: $scope});

    var tools = [
        {id: 'emptyexcel', name: 'Get empty excel-file for importing'},
        {id: 'export', name: 'Export'}
    ];

    $scope.getTool = function() {
        return _.findWhere($scope.fields, {name: 'tool'}).value?.id;
    };

    $scope.fields = [
        {name: 'tool', title: 'Tool', type: 'select', required: true, options: function() { return tools; }, useId: true},
        {name: 'datatype', title: 'Type', type: 'select', required: true, options: function() { return $scope.importdata && $scope.importdata.types; }, optionsFilter: function(f) { return $scope.getTool() == 'export' || f.canimport; }, useId: true, orderPredicate: 'translated' }
    ];

    server.get('/api/import/types/get').then(function(data) {
        $scope.importdata = data;
        data.types.forEach(function(t) {
            t.translated = $filter('translate')(t.name);
            (t.fields || []).forEach(function(f) {
                f.translated = $filter('translate')(f.title);
            });

        });
        _.findWhere($scope.fields, {name: 'datatype'}).value = _.findWhere(data.types, {id: 'user'});
    });

    $scope.setInitialValues = function() {
        _.findWhere($scope.fields, {name: 'tool'}).value = _.findWhere(tools, {id: 'emptyexcel'});
    };

    $scope.getButtonText = function() {
        return 'Run';
    };

    $scope.submit = function() {
        var item = $scope.getSubmitItem();
        if (item.tool == 'emptyexcel') {
            $scope.loadingStatus.loading = true;
            server.get('/api/import/get_empty_excel', {type: item.datatype}, null, {responseType: 'blob'}).then(function(data) {
                var filename = $filter('translate')(_.findWhere($scope.importdata.types, {id: item.datatype}).name) + '.xlsx';
                util.download(filename, null, null, data);
                $scope.loadingStatus.loading = false;
            }, function() {
                $scope.loadingStatus.loading = false;
            });
        } else if (item.tool == 'export') {
            $scope.loadingStatus.loading = true;
            server.get('/api/import/export', {type: item.datatype}, null, {responseType: 'blob'}).then(function(data) {
                var filename = $filter('translate')(_.findWhere($scope.importdata.types, {id: item.datatype}).name) + '.xlsx';
                util.download(filename, null, null, data);
                $scope.loadingStatus.loading = false;
            }, function() {
                $scope.loadingStatus.loading = false;
            });
        }
    };

    $scope.setInitialValues();
}]);

importer.controller('ImportBrpCtrl', ['$rootScope', '$scope', 'server', 'util', '$controller', function($rootScope, $scope, server, util, $controller) {
    $controller('AddCtrl', {$scope:$scope});

    $scope.loadingStatus = { loading: false};

    $scope.getButtonText = function() {
        return 'Hämta data';
    };

    var datatypes = [
        {id: 'customer', name: 'Customers'},
        {id: 'trainingcard', name: 'Training cards'},
        {id: 'journal', name: 'Journal entries'},
        {id: 'product', name: 'Products'},
        {id: 'productcategory', name: 'Product categories'},
        {id: 'account', name: 'Accounts'},
        {id: 'giftcard', name: 'Gift cards and value cards'},
        {id: 'consent', name: 'Direct debit consents'},
        {id: 'resource', name: 'Resources'},
        {id: 'resourcebookingservice', name: 'Resource booking services'},
        {id: 'resourcebooking', name: 'Resource bookings'},
        {id: 'company', name: 'Companies'}
    ];

    var resultFormats = [{id: 'xlsx', name: 'xlsx'}, {id: 'csv', name: 'csv'}];

    $scope.fields = [
        {name: 'type', title: 'Välj typ', type: 'select', options: function() { return datatypes; }, required: true, useId: true},
        {name: 'limit', title: 'Antal att hämta', type: 'number', placeholder: 'Hämta samtliga'},
        {name: 'historic', title: 'Även historiska', type: 'checkbox', visible: function() { var v =_.findWhere($scope.fields, {name: 'type'}).value; return v && v.id == 'trainingcard'; }},
        {name: 'format', title: 'Format', type: 'select', options: function() { return resultFormats; }, required: true, useId: true},
    ];

    $scope.submit = function() {
        var item = $scope.getSubmitItem();
        $scope.loadingStatus.loading = true;
        var filter = {
            historic: item.historic
        };
        filter = JSON.stringify(filter);
        var format = item.format || 'xlsx';
        server.get('/api/import/exportbrp', {type: item.type, limit: item.limit, filter: filter, format: format}, null, {responseType: 'blob'}).then(function(data) {
            var filename = util.t(_.findWhere(datatypes, {id: item.type}).name) + '.' + format;
            util.download(filename, null, null, data);
            $scope.loadingStatus.loading = false;
        }, function() {
            $scope.loadingStatus.loading = false;
        });
    };
}]);
